export const subscriptionApiErrorMessages = {
  currentBillingCycleStatusIsUnknown: 'Das nächste Bestelldatum kann nicht geändert werden',
  rebillInProgress:
    'Das nächste Bestelldatum kann nicht geändert werden: Wiederabrechnung in Bearbeitung',
  paymentFailed: 'Das nächste Bestelldatum kann nicht geändert werden: Zahlung fehlgeschlagen'
};
